module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-5.a230598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-5.jpg
// module id = ws1Y
// module chunks = 52